import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "የኩኪ ማስታወቂያ",
    description:
      "ይህ ድር ጣቢያ በትክክል እንዲሰራ አስፈላጊ ኩኪዎችን እንጠቀማለን። እንዲሁም እንዴት ከድር ጣቢያችን ጋር እንደምትገናኙ ለማረዳት አማራጭ የኩኪ መከታተያዎችን እንጠቀማለን። እነዚህ የኩኪ ዋስትናዎች በፈቃደኛነትዎ ብቻ ይሰናዳሉ።",
    acceptAllBtn: "ሁሉንም ተቀበል",
    acceptNecessaryBtn: "ሁሉንም አልተቀበልም",
    showPreferencesBtn: "የግል ምርጫዎችን አስተዳድር",
  },
  preferencesModal: {
    title: "የኩኪ ምርጫዎችን አስተዳድር",
    acceptAllBtn: "ሁሉንም ተቀበል",
    acceptNecessaryBtn: "ሁሉንም አልተቀበልም",
    savePreferencesBtn: "የአሁኑን ምርጫ ተቀበል",
    closeIconLabel: "መስኮቱን ዝጋ",
    sections: [
      {
        title: "የኩኪ አጠቃቀም",
        description:
          "ኛም የድር ጣቢያውን አስፈላጊ ተግባሮች ለማግደል እና የእርስዎን የአለም አየር ልምድ ለማሻሻል ኩኪዎችን እንጠቀማለን።",
      },
      {
        title: "በጣም አስፈላጊ ኩኪዎች",
        description:
          "እነዚህ ኩኪዎች ለድር ጣቢያው በትክክል እንዲሰራ አስፈላጊ ናቸው፣ ለምሳሌ ለተጠቃሚ ማረጋገጫ።",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "ስም",
            domain: "አገልግሎት",
            description: "መግለጫ",
            expiration: "የጊዜ ጨርሶ",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description: "ኩኪ በዲጂታል ማህበረሰብ መድረክ ለተጠቃሚ ማረጋገጫ ተዘጋጀ።",
              expiration: "ክፍለ ጊዜ",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description: "ኩኪ በዲጂታል ማህበረሰብ መድረክ ለተጠቃሚ ማረጋገጫ ተዘጋጀ",
              expiration: "ክፍለ ጊዜ",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "ይህ ኩኪ ሰዎችን ከማሽኖች ለመለየት እና ድር ጣቢያውን ከራስ-ሰር ጥቃቶች ለመከላከል ይረዳል። ምንም የግል መረጃ አይወሰድም።",
              expiration: "30 ደቂቃ",
            },
          ],
        },
      },
      {
        title: "ትንተና",
        description:
          "የትንተና ኩኪዎች መረጃ ለመሰብሰብ እና ተጠቃሚዎች ከአገልግሎት ጋር እንዴት እንደሚገናኙ ለማረዳት ይረዱ። እነዚህ ግንዛቤዎች አስተዋጽኦን ለማሻሻል ተጠቃሚ ተሞክሮን ይጨምራሉ።",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "ስም",
            domain: "አገልግሎት",
            description: "መግለጫ",
            expiration: "የጊዜ ጨርሶ",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'ኩኪ በ <a href="https://business.safety.google/adscookies/">Google Analytics</a> ተዘጋጀ',
              expiration: "ከ12 ቀን በኋላ ይሰናዳል",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'ኩኪ በ <a href="https://business.safety.google/adscookies/">Google Analytics</a> ተዘጋጀ',
              expiration: "ክፍለ ጊዜ",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel = "ለትንተና የተመሠረተ ማከማቻ እንዲሰራ ያደርጋል፣ ለምሳሌ የጊዜ ቆይታ።";

export { translation, servicesLabel };
